import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import TransportComponent from '../components/transport.component';
import { selectTransportersListItems } from '../../../../../redux/transporters/selector';
import { transporters } from '../../../../../redux/transporters/action';
import { transporterSettings } from '../../../../../redux/transporter-setting/action';
import { selectTransporterSettingsQueryItems } from '../../../../../redux/transporter-setting/selector';

const ManagementTransportSettings = () => {
  const dispatch = useAppDispatch()
  const transportSettingsQuery = useSelector(selectTransporterSettingsQueryItems)
  const transporterListItems = useSelector(selectTransportersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectTransportSettings, setSelectTransportSettings] = useState<any>([])

  const fetchTransportSettingsQueryById = () => {
    dispatch(transporterSettings.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-configurations/query`,
      entity: 'transports',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectTransportSettings({ ...selectTransportSettings, [fields[0]]: value });
  }

  const fetchTransporterslistItems = () => {
    dispatch(transporters.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transporters/list`,
      entity: 'transporters',
      jsonData: {}
    }))
  }

  useEffect(
    () => {
      fetchTransportSettingsQueryById()
      fetchTransporterslistItems()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectTransportSettings(transportSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(transporterSettings.resetAction({ actionType: 'update' }))
    await dispatch(transporterSettings.update({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-configurations`,
      entity: 'transports',
      jsonData: {
        Records: [
          selectTransportSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <TransportComponent
          handleInnerFormChange={handleInnerFormChange}
          selectTransportSettings={selectTransportSettings}
          handleFormSubmit={handleFormSubmit}
          transporters={transporterListItems?.result?.items}
        />
      }
    </>
  )
};

export default ManagementTransportSettings;